import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const qrisRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/qris-payment',
  component: lazyRouteComponent(() => import('@/pages/qris/qris-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailQrisRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/qris-payment/$id',
  component: lazyRouteComponent(() => import('@/pages/qris/detail-qris-page')),
});
